import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class IntellectualpropertyService {

  constructor(private afdatabase: AngularFireDatabase) { }
  getProperty() {
    return this.afdatabase.list('/intellectualproperty');
  }
  getPropertyById(pid) {
    return this.afdatabase.object('/intellectualproperty/' + pid);
  }
  setProperty(property){
    return this.afdatabase.object('/intellectualproperty/' + property.pid).set(property);
  }
  getPropertyForStatus(status) {
    return this.afdatabase.list('/intellectualproperty', ref => ref.orderByChild('status').equalTo(status));
  }
}
